"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const material_kit_pro_react_1 = require("../assets/jss/material-kit-pro-react");
const hideable_1 = require("../hideable");
const ContainerDiv = (0, styles_1.styled)('div')(Object.assign(Object.assign({}, material_kit_pro_react_1.container), { marginTop: 24 }));
const TitleWrapper = (0, styles_1.styled)('div')({
    marginTop: 24,
    marginBottom: 16
});
const Container = ({ pageTitle, title, children }) => {
    React.useEffect(() => {
        if (pageTitle)
            document.title = pageTitle;
    }, [pageTitle]);
    return ((0, jsx_runtime_1.jsxs)(ContainerDiv, { children: [(0, jsx_runtime_1.jsx)(hideable_1.Hideable, Object.assign({ show: Boolean(title) }, { children: (0, jsx_runtime_1.jsx)(TitleWrapper, { children: title }) })), children] }));
};
exports.Container = Container;
//# sourceMappingURL=index.js.map